import graphql from "babel-plugin-relay/macro";

const AllNewsQuery = graphql`
query AllNewsQuery($politician:ID,$party:ID,$id:ID){
  allNews(politician:$politician,party:$party,id:$id){
    edges{
      node{
        id
        source
        shortDescription
        created
        link
        featuredImage
        featuredVideos
        newsContent
        newsType
        thumbnail
      }
    }
  }
}
`

export default AllNewsQuery;